export default {
    items: [
        {value: 0, label: 'Взрослый'},
        {value: 1, label: 'Ребенок'},
        {value: 2, label: 'Младенец'},
    ]
}